<div class="rounded px-2 py-1 font-medium text-xs badge" fxFlex="none" [ngClass]="class"><ng-content></ng-content></div>